export default "__VITE_ASSET__DmHX8s4r__"